import { render } from "./ToggleFavorite.vue?vue&type=template&id=6103ee4a"
import script from "./ToggleFavorite.vue?vue&type=script&lang=js"
export * from "./ToggleFavorite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__